import { render, staticRenderFns } from "./Lv1OrdinaTavolo.vue?vue&type=template&id=876efcd2"
import script from "./Lv1OrdinaTavolo.vue?vue&type=script&lang=js"
export * from "./Lv1OrdinaTavolo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports